import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridLaunchReportCellRenderer from "@/components/inputs/AGGridLaunchReportCellRenderer.vue";

export default class AGGridLaunchReportColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridLaunchReportCellRenderer;
    colDef.cellRendererParams = {
      metaData: this.column.metaData
    };
    return colDef;
  }
}
